import { render, staticRenderFns } from "./MdSb.vue?vue&type=template&id=9347e75a&scoped=true"
import script from "./MdSb.vue?vue&type=script&lang=js"
export * from "./MdSb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9347e75a",
  null
  
)

export default component.exports